import { UpdateValuesArrayType } from '../../types/apiResponse/tankTypes'
import { getData, patchData } from '../../utils'
import { reloadActiveRelations, reloadBatches, reloadSchool } from '../../utils/loadStorage'
import { SchoolState } from '../../store/school/useSchoolStore'

export const getUpdate = async (
  schoolIds: string[],
  updateDate: number,
  schoolList: SchoolState,
  setSchoolValues: (values: UpdateValuesArrayType, schoolList: SchoolState) => void,
  onClose: () => void,
  onOpen: () => void,
) => {
  await getData<UpdateValuesArrayType>(
    `/update?update-date=${updateDate}&${schoolIds.map((item) => `school-ids=${item}`).join('&')}`,
  )
    .then((response) => {
      setSchoolValues(response, schoolList)
      onClose()
      onOpen()
    })
    .catch(() => {
      console.log('Update API Error')
      alert('ERROR!')
    })
}

export const patchUpdate = async (
  updateDate: number,
  updateForm: UpdateValuesArrayType,
  schoolIds: string[],
  onClose: () => void,
) => {
  await patchData<string[]>(`/update?update-date=${updateDate}`, updateForm)
    .then(() => {
      reloadSchool(schoolIds)
      reloadBatches()
      reloadActiveRelations()
      onClose()
    })
    .catch(() => {
      console.log('Update API Error')
      alert('ERROR!!')
    })
}
